import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=afbfb9a8&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"
import style0 from "./UserList.vue?vue&type=style&index=0&id=afbfb9a8&prod&lang=css"
import style1 from "./UserList.vue?vue&type=style&index=1&id=afbfb9a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbfb9a8",
  null
  
)

export default component.exports